import styled from "styled-components";

export const SectionCard = styled.div`
    width: 100%;
    background: white;
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    padding: 28px 24px;
    box-sizing: border-box;

    @media (max-width: 480px) {
        padding: 20px 16px;
        border-radius: 12px;
    }
`;

export const SectionTitle = styled.h2`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 600;
    font-size: 1.1rem;
    color: #333;
    margin: 0 0 20px 0;
`;

export const SubmitButton = styled.button`
    background-color: #006a61;
    width: 100%;
    color: white;
    border: none;
    border-radius: 8px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    font-size: 0.95rem;
    height: 44px;
    cursor: pointer;
    transition: background-color 0.2s;

    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
    pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};

    &:hover {
        background-color: #005a52;
    }
`;

export const CancelButton = styled.button`
    background-color: transparent;
    width: 100%;
    color: #666;
    border: 1.5px solid #ddd;
    border-radius: 8px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    font-size: 0.95rem;
    height: 44px;
    cursor: pointer;
    transition: all 0.2s;

    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
    pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};

    &:hover {
        background-color: #f5f5f5;
        border-color: #bbb;
    }
`;

export const ButtonsRow = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 8px;

    @media (max-width: 480px) {
        flex-direction: column-reverse;
    }
`;
